export enum AssignmentView {
  ASSIGNMENTS = 'assignments',
  CHAPTER = 'chapter',
}

export enum ChapterStrength {
  STRONG = 'strong',
  AVERAGE = 'average',
  WEAK = 'weak',
}

export enum LiveClassViews {
  CHAPTER = 'chapter',
  CLASS = 'class',
}

export enum SortBy {
  OLDEST = 'oldest',
  NEWEST = 'newest',
}

export enum ChipType {
  DANGER = 'danger',
  DARK = 'dark',
  DEFAULT = 'default',
  INFO = 'info',
  SUCCESS = 'success',
}
